module.exports = __webpack_public_path__ + "img/kia.59f0281a.png";